import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InstrumentoResumoView } from '../models/instrumento-avaliacao.types';

@Component({
  selector: 'app-instrumento-exclusao-confirmacao-modal',
  templateUrl: './instrumento-exclusao-confirmacao-modal.component.html'
})
export class InstrumentoExclusaoConfirmacaoModalComponent {
  @Input() aberta = false;
  @Input() instrumento: InstrumentoResumoView | null = null;
  @Input() confirmadoExclusao = false;

  @Output() confirmadoExclusaoChange = new EventEmitter<boolean>();
  @Output() confirmar = new EventEmitter<void>();
  @Output() cancelar = new EventEmitter<void>();

  onConfirmacaoChange(event: Event): void {
    const checked = (event.target as HTMLInputElement)?.checked ?? false;
    this.confirmadoExclusaoChange.emit(checked);
  }

  onConfirmar(): void {
    this.confirmar.emit();
  }

  onCancelar(): void {
    this.cancelar.emit();
  }
}
